import React from 'react'
import './services.css'

export const  Services = () => {
    
    return (
        <>
        
        <div className="service">
        <div className="heading"><h6>NOS SERVICES</h6></div>
        <div className="detail">
        <div className="row">
           <div className="column">
              <div className="card">
                 <div className="txt">
                    <h4>Dedouanement</h4>
                    <h4>Importation</h4>
                    <h4>Exportation</h4>
                 </div>
                 <div className="icon-wrapper">
                    <img src="./service/grue-port.jpg" alt="" />
                 </div>
              </div>
           </div>
           <div className="column">
              <div className="card">
              <div className="txt"> 
                    <h4>Conseil</h4>
                    <h4>Formation en projet</h4>
                    <h4>Import et Export</h4>
                </div>
                <div className="icon-wrapper">
                    <img src="./service/ampoule.jpg" alt="" />
                 </div>
              </div>
           </div>
           <div className="column">
              <div className="card">
              <div className="txt"> 
                    <h4>Négoce</h4>
                    <h4>Representation</h4>
                    <h4>Internationale</h4>
                </div>
                <div className="icon-wrapper">
                    <img src="./service/3942025.png" alt="" />
                 </div>
              </div>
           </div>
           <div className="column">
              <div className="card">
              <div className="txt"> 
                    <h4>Transit</h4>
                    <h4>Transport</h4>
                    <h4>(Ter, mer et air)</h4>
                </div>
                <div className="icon-wrapper">
                    <img src="./service/industrietransport.jpg" alt="" />
                 </div>
              </div>
           </div>
           <div className="column">
              <div className="card">
              <div className="txt"> 
                    <h4>Logistique</h4>
                    <h4>Manutention</h4>
                    <h4>Entreposage & Consignation</h4>
                </div>
                <div className="icon-wrapper">
                    <img src="./service/1966067.png" alt="" />
                 </div>
              </div>
           </div>
           <div className="column">
              <div className="card">
              <div className="txt"> 
                    <h4>Entreposage</h4>
                    <h4>Demenagement</h4>
                </div>
                <div className="icon-wrapper">
                    <img src="./service/755912.png" alt="" />
                 </div>
              </div>
           </div>
           <div className="column">
              <div className="card">
              <div className="txt"> 
                    <h4>Colis Fragile</h4>
                    <h4>Périsable</h4>
                </div>
                <div className="icon-wrapper">
                    <img src="./service/pallet-warehouse.png" alt="" />
                 </div>
              </div>
           </div>
           <div className="column">
              <div className="card">
              <div className="txt"> 
                    <h4>Petits Cargo</h4>
                    <h4>Contrats</h4>
                </div>
                <div className="icon-wrapper">
                    <img src="./service/livraison.jpg" alt="" />
                 </div>
              </div>
           </div>
        </div>
        </div>
            </div>
            </>
    )
  }